import compact from "lodash/compact";
import flatMap from "lodash/flatMap";
import get from "lodash/get";
import { createSelector } from "reselect";
import { NAMESPACE, PAGE_NAMESPACE } from "../constants";
export default createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].documents`, {}), (allDocuments) => compact(flatMap(allDocuments, (v) => v)));
